import {
  Button,
  ShareExternalIcon,
  type ButtonProps,
} from '@frontend/components';

type LearnMoreActionProps = ButtonProps & {
  url: string;
};

export const LearnMoreAction = ({ url, ...rest }: LearnMoreActionProps) => {
  return (
    <Button
      colorScheme="default"
      variant="link"
      size="sm"
      icon={<ShareExternalIcon />}
      as="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      Learn more
    </Button>
  );
};
